import { Stack } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'
import DeliveryCompaniesTable from 'components/orders/DeliveryCompaniesTable'
import { deliveryCompaniesQuery } from 'hooks/orders'

export const Route = createFileRoute('/_auth/_admin/admin/delivery-companies')({
  loader: async ({ context: { queryClient } }) => {
    return await queryClient.ensureQueryData(deliveryCompaniesQuery)
  },
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Stack gap="xl" mt="xl">
      <DeliveryCompaniesTable />
    </Stack>
  )
}
